import type { ErrorInfo } from "../types";

type ErrorMessageProps = {
  errorInfo: ErrorInfo;
};

export function ErrorMessage({ errorInfo }: ErrorMessageProps) {
  const message = errorInfo.devDetails.errorMessage || "(No message)";

  return (
    <div>
      <h4 className="mb-2 font-semibold text-red-800">Error Message:</h4>
      <div className="rounded bg-white p-3 font-mono text-sm text-red-700">
        {message}
      </div>
    </div>
  );
}
